import { enableProdMode, importProvidersFrom, APP_INITIALIZER, InjectionToken, LOCALE_ID } from '@angular/core';
import 'hammerjs';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NexiaStoreModule } from './app/redux/nexia-store/nexia-store.module';
import { appRoutes } from './app/app.routes';
import { CustumShouldReuseRouteFalseForTaskDetail } from './app/entry-routes/task/task-details/custum-should-reuse-route-false-for-task-detail';
import { RouteReuseStrategy, withRouterConfig, provideRouter } from '@angular/router';
import { HAMMER_GESTURE_CONFIG, BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import {
    MsalInterceptor,
    MsalGuard,
    MSAL_INSTANCE,
    MSAL_GUARD_CONFIG,
    MSAL_INTERCEPTOR_CONFIG, MsalService, MsalBroadcastService
} from '@azure/msal-angular';
import { HttpErrorInterceptor } from './app/entry-routes/http-error-interceptor/http-error-interceptor';
import { AuthenticationInterceptor } from './app/entry-routes/authentication/authentication-interceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient, HttpClient } from '@angular/common/http';
import { AppInitializerService } from './app/core/services/app-initializer.service';
import { HammerConfig } from './hammer-config';
import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './msal.config';
import { EntitySearchResultService } from './app/core/redux/search-result/service/entity-search-result.service';
import { EntityFilterService } from './app/core/redux/filter/service/entity-filter.service';
import { EntitySearchItemsService } from './app/core/redux/search-item/service/entity-search-items.service';
import { GedAutocompletionService } from './app/entry-routes/search/service/autocompletion/ged-autocompletion.service';
import { IndexationService } from './app/core/redux/indexation/service/indexation.service';
import { DraftFilterService } from './app/core/redux/filter/service/draft-filter.service';
import { DocumentSearchResultService } from './app/core/redux/search-result/service/document-search-result.service';
import { DocumentFilterService } from './app/core/redux/filter/service/document-filter.service';
import { DocumentSearchItemsService } from './app/core/redux/search-item/service/document-search-item.service';
import { TaskSearchResultService } from './app/core/redux/search-result/service/task-search-result.service';
import { TaskFilterService } from './app/core/redux/filter/service/task-filter.service';
import { TaskSearchItemsService } from './app/core/redux/search-item/service/task-search-item.service';
import { WkfAutocompletionService } from './app/entry-routes/search/service/autocompletion/wkf-autocompletion.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { CustomDateFormat } from './app/core/models/date-format-by-locale';
import { ToastaConfig, ToastaService } from 'ngx-toasta';
import { ScreenWidthService } from './app/core/services/responsive/screen-width.service';
import { ScrollEventService } from './app/core/services/event/scroll-event.service';
import { LocaleService } from './app/core/services/locale/locale.service';
import { LoadableThesaurusService } from './app/core/ui/thesaurus/service/loadable-thesaurus.service';
import { TreeService } from './app/core/ui/thesaurus/service/tree.service';
import { IconResolverService } from './app/core/services/icon-resolver.service';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import {
    WkfSupervisionSearchResultService
} from './app/core/redux/search-result/service/wkf-supervision-search-result.service';
import { WkfSupervisionFilterService } from './app/core/redux/filter/service/wkf-supervision-filter.service';
import { WkfSupervisionItemsService } from './app/core/redux/search-item/service/wkf-supervision-items.service';
import {  ModuleRegistry, AllCommunityModule } from 'ag-charts-community';
import {
    WkfSupervisionAutocompletionService
} from './app/entry-routes/search/service/autocompletion/wkf-supervision-autocompletion.service';

const interceptors = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthenticationInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpErrorInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true
  }
];

export const ENTITY_SEARCH_RESULT_SERVICE_TOKEN = new InjectionToken<string>('EntitySearchResultService');
export const ENTITY_FILTER_SERVICE_TOKEN = new InjectionToken<string>('EntityFilterService');
export const ENTITY_SEARCH_ITEMS_SERVICE_TOKEN = new InjectionToken<string>('EntitySearchItemsService');
export const GED_AUTOCOMPLETION_SERVICE_TOKEN: InjectionToken<string> = new InjectionToken<string>('GedAutocompletionService');
export const INDEXATION_SERVICE_TOKEN = new InjectionToken<string>('IndexationService');
export const DRAFT_FILTER_SERVICE_TOKEN = new InjectionToken<string>('DraftFilterService');
export const DOCUMENT_SEARCH_RESULT_SERVICE_TOKEN = new InjectionToken<string>('DocumentSearchResultService');
export const DOCUMENT_FILTER_SERVICE_TOKEN = new InjectionToken<string>('DocumentFilterService');
export const DOCUMENT_SEARCH_ITEMS_SERVICE_TOKEN = new InjectionToken<string>('DocumentSearchItemsService');
export const TASK_SEARCH_RESULT_SERVICE_TOKEN: InjectionToken<string> = new InjectionToken<string>('TaskSearchResultService');
export const TASK_FILTER_SERVICE_TOKEN: InjectionToken<string> = new InjectionToken<string>('TaskFilterService');
export const TASK_SEARCH_ITEMS_SERVICE_TOKEN: InjectionToken<string> = new InjectionToken<string>('TaskSearchItemsService');
export const WKF_AUTOCOMPLETION_SERVICE_TOKEN: InjectionToken<string> = new InjectionToken<string>('WkfAutocompletionService');

export const WKFSUPERVISION_SEARCH_RESULT_SERVICE_TOKEN: InjectionToken<string> = new InjectionToken<string>('WkfSupervisionSearchResultService');
export const WKFSUPERVISION_FILTER_SERVICE_TOKEN: InjectionToken<string> = new InjectionToken<string>('WkfSupervisionFilterService');
export const WKFSUPERVISION_SEARCH_ITEMS_SERVICE_TOKEN: InjectionToken<string> = new InjectionToken<string>('WkfSupervisionItemsService');
export const WKFSUPERVISION_AUTOCOMPLETION_SERVICE_TOKEN: InjectionToken<string> = new InjectionToken<string>('WkfSupervisionAutocompletionService');

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

if (environment.production) {
  enableProdMode();
}
registerLocaleData(localeFr);


ModuleRegistry.registerModules([
    AllCommunityModule
]);


bootstrapApplication(AppComponent,  {
    providers: [
        importProvidersFrom(NexiaStoreModule, BrowserModule, TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }), StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
        }),  MatIconModule, MatSidenavModule
            ),
        ...interceptors,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: HammerConfig
        },

        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory,
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory,
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true,
        },


        { provide: RouteReuseStrategy, useClass: CustumShouldReuseRouteFalseForTaskDetail },
        provideRouter(appRoutes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: APP_INITIALIZER,
            useFactory: (initService: AppInitializerService) => () => initService.init(),
            deps: [AppInitializerService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (iconResolverService: IconResolverService) => () => iconResolverService.registerIconResolver(),
            deps: [IconResolverService],
            multi: true
        },

        {
            provide: ENTITY_SEARCH_RESULT_SERVICE_TOKEN,
            useClass: EntitySearchResultService
        },
        {
            provide: ENTITY_FILTER_SERVICE_TOKEN,
            useClass: EntityFilterService
        },
        {
            provide: ENTITY_SEARCH_ITEMS_SERVICE_TOKEN,
            useClass: EntitySearchItemsService
        },
        {
            provide: GED_AUTOCOMPLETION_SERVICE_TOKEN,
            useClass: GedAutocompletionService
        },
        {
            provide: INDEXATION_SERVICE_TOKEN,
            useClass: IndexationService
        },
        {
            provide: DRAFT_FILTER_SERVICE_TOKEN,
            useClass: DraftFilterService
        },
        {
            provide: DOCUMENT_SEARCH_RESULT_SERVICE_TOKEN,
            useClass: DocumentSearchResultService
        },
        {
            provide: DOCUMENT_FILTER_SERVICE_TOKEN,
            useClass: DocumentFilterService
        },
        {
            provide: DOCUMENT_SEARCH_ITEMS_SERVICE_TOKEN,
            useClass: DocumentSearchItemsService
        },
        {
            provide: GED_AUTOCOMPLETION_SERVICE_TOKEN,
            useClass: GedAutocompletionService
        },
        {
            provide: TASK_SEARCH_RESULT_SERVICE_TOKEN,
            useClass: TaskSearchResultService
        },
        {
            provide: TASK_FILTER_SERVICE_TOKEN,
            useClass: TaskFilterService
        },
        {
            provide: TASK_SEARCH_ITEMS_SERVICE_TOKEN,
            useClass: TaskSearchItemsService
        },
        {
            provide: WKF_AUTOCOMPLETION_SERVICE_TOKEN,
            useClass: WkfAutocompletionService
        },
        {
            provide: WKFSUPERVISION_AUTOCOMPLETION_SERVICE_TOKEN,
            useClass: WkfSupervisionAutocompletionService
        },
        {
            provide: WKFSUPERVISION_SEARCH_RESULT_SERVICE_TOKEN,
            useClass: WkfSupervisionSearchResultService},
        {
            provide: WKFSUPERVISION_FILTER_SERVICE_TOKEN,
            useClass: WkfSupervisionFilterService
        },
        {
            provide: WKFSUPERVISION_SEARCH_ITEMS_SERVICE_TOKEN,
            useClass: WkfSupervisionItemsService
        },
        {
            provide: MAT_DATE_FORMATS,
            useClass: CustomDateFormat,
        },
        {
            provide: DateAdapter,
            useClass: NativeDateAdapter,
        },
        ToastaService,ToastaConfig,
        ScreenWidthService,
        ScrollEventService,
        {
            provide: LOCALE_ID,
            deps: [LocaleService],
            useFactory: (localeService) => localeService.getLocale()
        },
        LoadableThesaurusService,
        TreeService,
        importProvidersFrom(MatIconModule),
        { provide: MAT_DATE_LOCALE, useValue: 'fr'},
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS}
    ]
})
  .catch((err: Error) => {
    console.log(err.name, err.message);
    // eslint-disable-next-line no-console
    console.trace(err.stack);
  });
